import "./style.css";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { RiArrowDownSLine } from "react-icons/all";

const faqSections = [
  {
    title: "Rreth CapitalPay",
    items: [
      {
        question: "Cka eshte CapitalPay?",
        answer: (
          <>
            <p>
              CapitalPay eshte kuleta juaj digjitale, e e krijuar per t'ju
              mundesuar pagesa dhe transfere parash nga telefoni 24/7, pa pasur
              nevoje te shkoni cdo here ne sportel.
            </p>
            <p>
              CapitalPay eshte produkt i IFJB Capital SH.P.K, Institucion i
              licencuar nga Banka Qendrore e Kosoves.
            </p>
            <p>
              Me CapitalPay mund te kryeni pagesa te faturave dhe per biznese,
              apo te pranoni dhe dergoni para si dhe ne te njejten kohe ju mund
              te kontrolloni transaksionet dhe te menaxhoni parate tuaja me
              lehte, me shpejt dhe me sigurt.
            </p>
          </>
        ),
      },
      {
        question: "Pse me perdor CapitalPay?",
        answer: (
          <>
            <p>
              CapitalPay ju kursen kohe dhe ju jep qasje ne pagesa kudo qe
              jeni. Nuk keni nevoje te prisni ne radhe, te mbani fatura me vete
              apo te shkoni fizikisht ne lokacion per cdo pagese.
            </p>
            <p>
              Permes aplikacionit mund te kryeni pagesa 24/7, direkt nga
              telefoni juaj.
            </p>
          </>
        ),
      },
      {
        question: "Cfare sherbimesh mund te kryej me CapitalPay?",
        answer: (
          <>
            <p>Permes CapitalPay mund te kryeni pagesa per:</p>
            <ul>
              <li>gjoba te policise;</li>
              <li>internet dhe TV;</li>
              <li>ujesjelles;</li>
              <li>tatime dhe kontribute;</li>
              <li>pagesa te tjera vendore;</li>
              <li>pagesa ne dyqane (biznese);</li>
              <li>transfere parash;</li>
              <li>rimbushje te llogarise.</li>
            </ul>
            <p>
              Lista e sherbimeve mund te perditesohet me kohe, varesisht nga
              sherbimet e reja qe shtohen ne aplikacion.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Hapja e llogarise",
    items: [
      {
        question: "Si mund te hap llogari ne CapitalPay?",
        answer: (
          <>
            <p>Per te hapur llogari:</p>
            <ul>
              <li>Shkarkoni aplikacionin CapitalPay.</li>
              <li>Shkruani numrin tuaj te telefonit.</li>
              <li>Konfirmoni kodin qe ju vjen me SMS.</li>
              <li>Plotesoni te dhenat e kerkuara.</li>
              <li>Kryeni verifikimin e identitetit.</li>
              <li>Prisni aprovimin e llogarise.</li>
            </ul>
            <p>
              Pas aprovimit, mund te filloni ta perdorni CapitalPay.
            </p>
          </>
        ),
      },
      {
        question: "Cka me duhet per t'u regjistruar?",
        answer: (
          <>
            <p>Per regjistrim ju nevojiten:</p>
            <ul>
              <li>numer telefoni aktiv;</li>
              <li>email.</li>
              <li>dokument identifikimi;</li>
              <li>fotografi/selfie per verifikim;</li>
              <li>nje fature e adreses se banimit;</li>
            </ul>
            <p>
              Te dhenat duhet te jene te sakta dhe dokumenti duhet te jete i
              vlefshem.
            </p>
          </>
        ),
      },
      {
        question: "A mund te hap llogari te biznesit ne CapitalPay?",
        answer: (
          <>
            <p>
              Po, me CapitalPay ju mund te krijoni edhe llogari per biznesin
              tuaj.
            </p>
            <p>
              Llogaria e biznesit ju mundeson pranimin e pagesave nga klientet
              permes CapitalPay, ne menyre te thjeshte dhe te sigurt.
            </p>
          </>
        ),
      },
      {
        question: "A mund ta perdor CapitalPay me numer jashte Kosoves?",
        answer: (
          <p>
            Per momentin CapitalPay mund te perdoret vetem me numer te Kosoves
            me prefiksin +383, CapitalPay hapet nga cdo shtet ne Evrope.
          </p>
        ),
      },
    ],
  },
  {
    title: "Verifikimi",
    items: [
      {
        question: "Pse kerkohet verifikimi i identitetit?",
        answer: (
          <p>
            Verifikimi behet per sigurine tuaj dhe per te parandaluar
            keqperdorimin e llogarive. Ky eshte hap i nevojshem per sherbime
            financiare digjitale.
          </p>
        ),
      },
      {
        question: "Sa zgjat aprovimi i llogarise?",
        answer: (
          <p>
            Aprovimi mund te zgjase varesisht nga ngarkesa dhe saktesia e te
            dhenave qe keni dorezuar. Nese dokumentet jane te qarta dhe te
            dhenat jane te sakta, procesi zakonisht kryhet shume shpejte.
          </p>
        ),
      },
      {
        question: "A mund te mos aprovohet llogaria?",
        answer: (
          <>
            <p>Llogaria mund te mos aprovohet nese:</p>
            <ul>
              <li>dokumenti eshte i paqarte;</li>
              <li>fotografia nuk perputhet me dokumentin;</li>
              <li>te dhenat jane shkruar gabim;</li>
              <li>dokumenti ka skaduar;</li>
              <li>mungon ndonje informate e nevojshme.</li>
            </ul>
            <p>
              Ne kete rast mund te kerkohet korrigjim ose dorezim i ri i
              dokumenteve.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Mbushja e llogarise",
    items: [
      {
        question: "Si mund ta mbush llogarine time?",
        answer: (
          <>
            <p>
              Per te mbushur llogarine tuaj ne CapitalPay, mund te perdorni
              njeren nga menyrat e meposhtme:
            </p>
            <p>1. Ne deget e Capital:</p>
            <ul>
              <li>Vizitoni njeren nga deget e Capital ne Kosove,</li>
              <li>
                Njoftoni operatorin se deshironi te beni mbushje te llogarise
                CapitalPay,
              </li>
              <li>
                Duhet te keni nje dokument identifikues (ID, Pasaport apo
                Patent shofer),
              </li>
              <li>
                Dorezoni shumen qe deshironi ta mbushni llogarine dhe fondet do
                te transferohen menjehere ne llogarine tuaj ne CapitalPay.
              </li>
            </ul>
            <p>Pa provizion dhe ne mbi 200 lokacione ne gjithe Kosoven!</p>
            <p>2. Permes transferit bankar:</p>
            <ul>
              <li>
                Hapni eBanking apo mBanking te bankes suaj pastaj zgjidhni
                opsionin "Transfer Kombetar" ose emertim te ngjashem,
              </li>
              <li>
                Tek llogaria e perfituesit, shkruani IBAN-in e llogarise suaj
                ne CapitalPay:
              </li>
              <li>
                Tek pershkrimi mund te shkruani transfer apo mbushje e
                llogarise.
              </li>
            </ul>
            <p>
              Pasi fondet te pranohen nga CapitalPay, ato do te transferohen
              menjehere ne llogarine tuaj elektronike.
            </p>
            <p>
              Transferet bankare procesohen sipas afateve te bankes derguese
              dhe sistemit nderbankar.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Terheqje e mjeteve nga llogaria",
    items: [
      {
        question: "Si mund t'i terheq mjetet nga llogaria ime?",
        answer: (
          <>
            <p>
              Per te terhequr mjetet nga llogaria juaj ne CapitalPay mund te
              perdorni njeren nga menyrat e meposhtme:
            </p>
            <p>1. Ne deget e Capital:</p>
            <ul>
              <li>Vizitoni njeren nga deget e Capital ne Kosove</li>
              <li>
                Njoftoni operatorin se deshironi te terhiqni para nga llogaria e
                CapitalPay,
              </li>
              <li>
                Duhet te keni nje dokument identifikues (ID, Pasaport apo
                Patent shofer),
              </li>
            </ul>
            <p>
              Sherbimi per terheqje te mjeteve nga CapitalPay ne secilen prej
              degeve te Capital kushton vetem 0.50€.
            </p>
            <p>2. Permes transferit bankar:</p>
            <ul>
              <li>Ne faqen kryesore klikoni ne butonin “Terheqje”,</li>
              <li>
                Shtoni nje llogari bankare tek e cila deshironi ti transferoni
                mjetet tuaja (shenoni te dhenat e sakta te llogarise duke i
                plotesuar fushat e shfaqura),
              </li>
              <li>
                Pasi te keni krijuar llogarine ju mund te zgjidhni ate llogari
                per te transferuar mjetet (zgjedh llogarine e perfituesit),
              </li>
              <li>
                Plotesoni te dhenat e kerkuara dhe klikoni butonin per te
                vazhduar, pastaj shfaqet dritarja per konfirmimin e transferit
                ne te cilen ju kontrolloni nese gjithcka eshte ne rregull per
                te realizuar terheqjen.
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    title: "Pagesat",
    items: [
      {
        question: "Si behet nje pagese e fatures ne CapitalPay?",
        answer: (
          <>
            <p>
              Duke skenuar barkodin apo kodin QR permes opsionit per skenim ne
              faqen kryesore
            </p>
            <p>Ose:</p>
            <ul>
              <li>Ne faqen kryesore zgjidhni opsionin PAGUANI FATURAT</li>
              <li>Zgjidhni kategorine e pageses.</li>
              <li>Shkruani te dhenat e kerkuara.</li>
              <li>Kontrolloni shumen dhe te dhenat.</li>
              <li>Konfirmoni pagesen.</li>
            </ul>
          </>
        ),
      },
      {
        question: "Si mund te paguaj ne dyqane?",
        answer: (
          <>
            <p>
              Pasi te keni zgjedhur opsionin PAGUANI NE DYQANE qe ndodhet ne
              faqen kryesore.
            </p>
            <ol>
              <li>
                Zgjedhni dyqanin per te cilin do te paguani duke e kerkuar me
                emer apo duke e zgjedhur ne liste dyqanin per te cilin doni te
                paguani.
              </li>
              <li>Permes skenimit te kodit QR te vendosur ne dyqan,</li>
              <li>Permes numrit te telefonit te dyqanit.</li>
            </ol>
          </>
        ),
      },
      {
        question: "Ku e gjej deshmine e pageses?",
        answer: (
          <p>
            Deshmine e pageses mund ta gjeni ne faqen kryesore ose ne historikun
            e transaksioneve.
          </p>
        ),
      },
      {
        question: "A mund ta anuloj nje pagese pasi e konfirmoj?",
        answer: (
          <p>
            Ne shumicen e rasteve, pagesat e konfirmuara nuk mund te anulohen.
            Nese keni bere gabim, kontaktoni menjehere mbeshtetjen e
            CapitalPay.
          </p>
        ),
      },
    ],
  },
  {
    title: "Transferet",
    items: [
      {
        question: "A mund te dergoj/pranoj para me/nga CapitalPay?",
        answer: (
          <>
            <p>
              Po. CapitalPay mundeson dergim dhe pranim te parave te nje
              perdorues tjeter i CapitalPay permes numrit te telefonit, numrit
              te llogarise apo kodit QR.
            </p>
            <p>
              Ju gjithashtu mund te transferoni para edhe ne llogari bankare.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Hyrja ne aplikacion",
    items: [
      {
        question: "Si kycem ne CapitalPay?",
        answer: (
          <p>
            Ne aplikacion mund te kyceni me numer te telefonit dhe fjalekalimin
            qe keni vendosur.
          </p>
        ),
      },
      {
        question: "A mund te hyj me Face ID ose gjurme gishti?",
        answer: (
          <p>
            Po, nese telefoni juaj e mbeshtet kete funksion, mund te aktivizoni
            identifikimin biometrik per hyrje me te shpejte dhe me te sigurt.
          </p>
        ),
      },
      {
        question: "Kam harruar fjalekalimin. Cka duhet te bej?",
        answer: (
          <p>
            Perdorni opsionin rivendos fjalekalimin ne aplikacion permes sms apo
            emailit ose kontaktoni mbeshtetjen.
          </p>
        ),
      },
      {
        question: "Kam nderruar telefonin. A mund te hyj prape ne llogari?",
        answer: (
          <p>
            Po. Shkarkoni aplikacionin ne telefonin e ri dhe kycuni me numrin
            tuaj te telefonit.
          </p>
        ),
      },
    ],
  },
  {
    title: "Tarifat",
    items: [
      {
        question: "A ka tarife per hapjen e llogarise?",
        answer: <p>Hapja e llogarise eshte pa pagese.</p>,
      },
      {
        question: "A ka mirembajtje mujore?",
        answer: (
          <p>
            CapitalPay nuk ka tarife mujore te mirembajtjes se llogarise.
            Tarifat mund te aplikohen vetem per sherbime te caktuara, sipas
            cmimores zyrtare.
          </p>
        ),
      },
      {
        question: "Ku mund t'i shoh tarifat?",
        answer: (
          <p>
            Tarifat duhet te shfaqen para konfirmimit te transaksionit ose ne
            cmimoren zyrtare te CapitalPay. Para se te kryeni pagese,
            kontrolloni nese aplikohet ndonje tarife.
          </p>
        ),
      },
    ],
  },
  {
    title: "Siguria",
    items: [
      {
        question: "A eshte i sigurt CapitalPay?",
        answer: (
          <>
            <p>
              Po. CapitalPay perdor masa sigurie per mbrojtjen e llogarise, te
              dhenave dhe transaksioneve tuaja.
            </p>
            <p>
              Per siguri me te larte, mos e ndani me askend fjalekalimin apo
              kodin verifikues qe pranoni permes SMS.
            </p>
          </>
        ),
      },
      {
        question: "Cka duhet te bej nese dyshoj per keqperdorim?",
        answer: (
          <p>
            Nese vereni transaksione te panjohura ose dyshoni se dikush ka
            qasje ne llogarine tuaj, kontaktoni menjehere mbeshtetjen e
            CapitalPay.
          </p>
        ),
      },
    ],
  },
  {
    title: "Mbeshtetja",
    items: [
      {
        question: "Si mund te marr ndihme?",
        answer: (
          <>
            <p>
              Per ndihme rreth CapitalPay, mund te kontaktoni mbeshtetjen permes
              kanaleve zyrtare:
            </p>
            <ul>
              <li>Tel: 038600003</li>
              <li>Email: info@capital-ks.com</li>
            </ul>
            <p>
              Mbeshtetja mund t'ju ndihmoje per regjistrim, verifikim, pagesa,
              transfere, qasje ne llogari dhe probleme teknike eventuale.
            </p>
          </>
        ),
      },
    ],
  },
];

function FrequentlyAskedQuestionsSQ() {
  return (
    <div id="wrapper-page">
      <div id="first_page">
        <h1>Ndihma/Pyetjet e shpeshta</h1>
        {faqSections.map((section) => (
          <div key={section.title} className="faq-section">
            <h2>{section.title}</h2>
            <Accordion allowZeroExpanded>
              {section.items.map((item) => (
                <AccordionItem key={item.question}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      {item.question}
                      <RiArrowDownSLine />
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>{item.answer}</AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FrequentlyAskedQuestionsSQ;
